import React from 'react';
import createReactClass from 'create-react-class';
import Widget from './Widget';
import NeedsClaim from './NeedsClaim';
import Gravatar from 'react-gravatar';
import moment from 'moment';
import request from '../../helpers/request';
import appConfig from '../../config/appConfig';

var CommentsWidget = createReactClass({
  getInitialState() {
    return {
      purchaseId: null,
      comments: [],
      message: ''
    };
  },

  getDefaultProps(){
    return {
    };
  },

  componentDidMount() {
    if (this.props.fixedComments) {
      this.updateComments({
        comments: this.props.fixedComments});
    } else {
      request.get({
        url: appConfig.apiUrl + this.props.apiUrl,
        success: commentList => this.updateComments(commentList)
      });
    }
  },

  handleChange(e) {
    this.setState({
      message: e.target.value
    });
  },

  handleSubmit(e) {
    e.preventDefault();
    let {purchaseId, message} = this.state;

    if(!message) {
      return;
    }

    let newComment = {id: purchaseId, message};
    newComment = this.props.beforeSubmit(newComment);

    request.post({
      url: appConfig.apiUrl + this.props.apiUrl,
      data: newComment,
      success: commentList => this.updateComments(commentList)
    });
  },

  updateComments(commentList) {
    if (this.isMounted() && commentList) {
      this.setState({
        purchaseId: commentList.purchaseId,
        comments: commentList.comments,
        message: ''
      });
    }
  },

  render() {
    let comments = (<li className="message">Keine Kommentare vorhanden.</li>);

    if(this.state.comments.length > 0) {
      comments = this.state.comments.map(n => {
        let createdString = moment(n.dateCreated).format('DD.MM.YYYY HH:mm:ss');

        return (
          <li key={n.id} className="message">
            <Gravatar email={n.createdBy.email} size={50} rating="pg" default="mm" https className="online" />
            <div className="message-text">
              <time>
                {createdString}
              </time> <a className="username">{n.createdBy.name}</a> <span>{n.message}</span>
            </div>
          </li>
        );
      });
    }

    return (
      <Widget title="Kommentare" icon="comments" containerClassName={this.props.containerClassName}>
        <div id="chat-body" className="chat-body custom-scroll">
          <ul>
            {comments}
          </ul>
        </div>
        <NeedsClaim claim={this.props.claim}>
          <div className="chat-footer">
            <form>
              <div className="textarea-div">
                <div className="typearea">
                  <input
                    type="text"
                    value={this.state.message}
                    placeholder="Hinterlassen Sie ein Kommentar..."
                    className="form-control"
                    style={{border: 'none'}}
                    onChange={e => this.handleChange(e)} />
                </div>
              </div>

              <span className="textarea-controls">
                <button type="submit" className="btn btn-sm btn-primary pull-right" onClick={e => this.handleSubmit(e)}>Kommentieren</button>
                <span className="pull-right smart-form" style={{marginTop: 3, marginRight: 10}}></span>
              </span>
            </form>
          </div>
        </NeedsClaim>
      </Widget>
    );
  }
});

export default CommentsWidget;



// WEBPACK FOOTER //
// ./src/components/common/CommentsWidget.js